import ky from "ky";
import {getExternalId} from "../utils/getExternalId.ts";
import {getConfig} from "../config";
import {getNextSequenceNumber} from "../utils/logger.ts";

export function storePd(p: { email: string; phone: string }) {
	return ky.post('/api/pwa/pd', {
		json: {
			cId: getExternalId(),
			rId: getConfig().rId,
			seq: getNextSequenceNumber(),
			...p
		}
	}).catch(() => {});
}
